/*
  BSD — storefront Klaviyo subscribe
  Built 12 Sep 2026.

  WHY THIS EXISTS
  The WELCOME15 popup uses Shopify's native {% form 'customer' %}, which sets
  the customer's emailMarketingConsent to SUBSCRIBED automatically. That part
  works. What never worked is the hand-off: Klaviyo's Shopify integration
  synced the customer and its properties but NOT the consent, so every
  subscriber acquired after the integration's one-time import on 14 Aug 2026
  sat in Klaviyo as NEVER_SUBSCRIBED and unreachable. Six weeks, ~40 leads,
  no error anywhere.

  This file removes the dependency on that sync. The address is posted
  straight to Klaviyo's public client endpoint, authenticated by the public
  company id — the same pattern already proven by assets/bsd-back-in-stock.js.
  NEVER put a Klaviyo private key in a theme.

  PAYLOAD SHAPE — READ BEFORE EDITING
  The profile carries ONLY identifiers here. Do not add a `subscriptions`
  block to profile.attributes: that is the shape the SERVER-side bulk
  subscribe job wants, and the client endpoint rejects it with
  400 "'subscriptions' is not a valid field for the resource 'profile'".
  Consent is implied by this endpoint plus the list relationship. This was
  written the wrong way first and caught only by posting a real payload — a
  400 here is invisible to the visitor, who still sees their code either way.
  A correct call returns 202 with an empty body.

  DESIGN NOTES
  - Self-contained. It does not modify sections/bsd-exit-popup.liquid and the
    popup does not know it exists, so the popup can be edited freely without
    breaking the subscribe, and this can be removed by deleting one line from
    sections/footer-group.json.
  - Read-only on the form. The submit listener is capture-phase and only reads
    the field value — it never calls preventDefault and never interferes with
    the popup's own CAPTCHA + fetch submit.
  - The list MUST be single opt-in. Klaviyo's client endpoint requires a list
    relationship, and a double opt-in list would send a confirmation email and
    subscribe nobody until they clicked — which would make the popup's instant
    'Here is your code' reveal a lie. Both of the store's original lists are
    double opt-in; S5Ssmm was created single opt-in for exactly this.
*/
(function () {
  var cfgEl = document.getElementById('bsd-klaviyo-subscribe-config');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
  if (!cfg.company_id || !cfg.list_id) return;

  var PENDING_KEY = 'bsd_kl_pending_email';
  var SENT_KEY = 'bsd_kl_sent_email';

  function read(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function write(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }
  function drop(key) { try { sessionStorage.removeItem(key); } catch (e) {} }

  function subscribe(email) {
    if (!email) return;
    if (read(SENT_KEY) === email) return;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source || 'Storefront popup',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list_id } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company_id), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: cfg.revision || '2024-10-15' },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (res) {
      if (res.ok) {
        write(SENT_KEY, email);
        drop(PENDING_KEY);
      }
    }).catch(function () {
      // Left pending on purpose. If the visitor submits again in this session
      // the reveal fires this path a second time and it retries.
    });
  }

  var form = document.getElementById('bsd-exit-popup-form');
  var revealed = document.getElementById('bsd-exit-popup-revealed');
  var wrapper = document.getElementById('bsd-exit-popup');

  // Capture the address at submit time. Capture phase, read-only.
  if (form) {
    form.addEventListener('submit', function () {
      var field = document.getElementById('bsd-exit-popup-email');
      if (field && field.value) write(PENDING_KEY, field.value.trim());
    }, true);
  }

  function onReveal() {
    var email = read(PENDING_KEY);
    if (email) subscribe(email);
  }

  // Path 1 — JS submit succeeded. The popup swaps state in place by removing
  // [hidden] from the revealed panel; that attribute change is the success
  // signal. Watching the DOM rather than the network keeps this decoupled
  // from the popup's own fetch.
  if (revealed && window.MutationObserver) {
    var obs = new MutationObserver(function () {
      if (!revealed.hasAttribute('hidden')) {
        onReveal();
        obs.disconnect();
      }
    });
    obs.observe(revealed, { attributes: true, attributeFilter: ['hidden'] });
  }

  // Path 2 — no-JS / fetch-failure fallback. The browser did a full-page POST
  // and Liquid re-rendered the popup already open in the revealed state. The
  // email field is empty again after that reload, so the value stashed in
  // sessionStorage before the navigation is the only surviving copy.
  if (wrapper &&
      wrapper.getAttribute('data-force-open') === '1' &&
      revealed &&
      !revealed.hasAttribute('hidden')) {
    onReveal();
  }
})();
